// extracted by mini-css-extract-plugin
module.exports = {"chipDefault":"Chip_chipDefault__FFuP9","text":"Chip_text__3mGC3"};